var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSquarePlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16683H12.5M10 6.66683V11.6668M17.5 16.6668L14.7297 15.2817C14.5197 15.1767 14.4147 15.1242 14.3047 15.0872C14.207 15.0543 14.1064 15.0306 14.0043 15.0163C13.8893 15.0002 13.7719 15.0002 13.5372 15.0002H5.16667C4.23325 15.0002 3.76654 15.0002 3.41002 14.8185C3.09641 14.6587 2.84144 14.4038 2.68166 14.0901C2.5 13.7336 2.5 13.2669 2.5 12.3335V6.00016C2.5 5.06674 2.5 4.60003 2.68166 4.24351C2.84144 3.92991 3.09641 3.67494 3.41002 3.51515C3.76654 3.3335 4.23325 3.3335 5.16667 3.3335H14.8333C15.7668 3.3335 16.2335 3.3335 16.59 3.51515C16.9036 3.67494 17.1586 3.92991 17.3183 4.24351C17.5 4.60003 17.5 5.06674 17.5 6.00016V16.6668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquarePlus);
export default __webpack_public_path__ + "static/media/message-square-plus.35e9da935547e6476aa719fddf91eff4.svg";
export { ForwardRef as ReactComponent };